<div class="reports-button" routerLink="report/report-requests">
    <i class="fa-regular fa-file file-icon" style="font-size: 20px; width: 20px;"></i>
    {{ "reports.myReports" | translate}}
</div>

